"use client";

import { c as _c } from "react/compiler-runtime";
import { createSavedTender, deleteSavedTender } from "@/actions/save-tender";
import { Button } from "@/components/ui/button";
import { Star } from "lucide-react";
import { useRouter } from "next/navigation";
import { useState, useTransition } from "react";
import { toast } from "sonner";
interface SaveTenderButtonProps {
  tenderId: number;
  initialSaved?: boolean;
  initialSavedRecordId?: number | null;
  className?: string;
}
const QUOTA_REDIRECT_DELAY_MS = 1500;
export function SaveTenderButton(t0) {
  const $ = _c(15);
  const {
    tenderId,
    initialSaved: t1,
    className: t2
  } = t0;
  const initialSaved = t1 === undefined ? false : t1;
  const className = t2 === undefined ? "" : t2;
  const router = useRouter();
  const [saved, setSaved] = useState(initialSaved);
  const [isPending, startTransition] = useTransition();
  let t3;
  if ($[0] !== router || $[1] !== saved || $[2] !== tenderId) {
    t3 = () => {
      startTransition(() => {
        if (!saved) {
          createSavedTender(tenderId).then(res => {
            if (res.errors.tender) {
              if (res.quotaExceeded) {
                toast.error("Has excedido la cuota de tu plan", {
                  description: `${res.errors.tender} Te llevamos a los planes…`
                });
                setTimeout(() => router.push("/pricing"), QUOTA_REDIRECT_DELAY_MS);
              } else {
                toast.error("Error", {
                  description: res.errors.tender
                });
              }
              return false;
            }
            setSaved(true);
            toast.success(res.values.tender);
            return true;
          }).catch(_temp);
        } else {
          const prevSaved = saved;
          setSaved(false);
          deleteSavedTender(tenderId).then(res_0 => {
            if (!res_0.success) {
              setSaved(prevSaved);
              toast.error("Error", {
                description: res_0.error
              });
              return false;
            }
            toast.success("Eliminada de favoritos");
            return true;
          }).catch(() => {
            setSaved(prevSaved);
            toast.error("Error", {
              description: "No se pudo eliminar la licitaci\xF3n guardada. Int\xE9ntalo m\xE1s tarde."
            });
          });
        }
      });
    };
    $[0] = router;
    $[1] = saved;
    $[2] = tenderId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClick = t3;
  const t4 = `size-8 ${className}`;
  const t5 = saved ? "Quitar de favoritos" : "Guardar y recibir notificaciones";
  const t6 = saved ? "default" : "outline";
  const t7 = saved ? "Quitar de favoritos" : "Guardar licitaci\xF3n";
  const t8 = `size-4 ${saved ? "fill-current" : ""}`;
  let t9;
  if ($[4] !== t8) {
    t9 = <Star className={t8} />;
    $[4] = t8;
    $[5] = t9;
  } else {
    t9 = $[5];
  }
  let t10;
  if ($[6] !== handleClick || $[7] !== isPending || $[8] !== saved || $[9] !== t4 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t9) {
    t10 = <Button className={t4} size="icon" title={t5} variant={t6} onClick={handleClick} disabled={isPending} aria-pressed={saved} aria-label={t7}>{t9}</Button>;
    $[6] = handleClick;
    $[7] = isPending;
    $[8] = saved;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  return t10;
}
function _temp() {
  toast.error("Error", {
    description: "No se pudo guardar la licitaci\xF3n. Int\xE9ntalo en unos minutos."
  });
}
export default SaveTenderButton;